import React, {ReactNode} from "react"
import {ContentBannerWrapper} from "./components"

type Club25ContentWrapperProps = {
    children: ReactNode
    quickLinkCount: number
    enableContentBanner: boolean
    showCountrySelector: boolean
    xxlBreakpointEnabled: boolean
}

export const Club25ContentWrapper = (props: Club25ContentWrapperProps) => {
    const {children, quickLinkCount, enableContentBanner, showCountrySelector, xxlBreakpointEnabled} = props

    return (
        <ContentBannerWrapper
            quickLinkCount={quickLinkCount}
            enableContentBanner={enableContentBanner}
            showCountrySelector={showCountrySelector}
            xxlBreakpointEnabled={xxlBreakpointEnabled}
        >
            {children}
        </ContentBannerWrapper>
    )
}

export default Club25ContentWrapper
